/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentRequestV1PaymentMethod {
    DOMESTIC = 'Domestic',
    INPAYMENT_FORM = 'InpaymentForm',
    SEPA = 'SEPA',
}